function initMadesaCountdowns() {
  var countdownRoots = document.querySelectorAll('[data-bf-countdown-root]:not([data-initialized])');

  countdownRoots.forEach(function(root) {
    root.setAttribute('data-initialized', 'true');

    var startStr = root.getAttribute('data-start') || '';
    var endStr = root.getAttribute('data-end') || '';
    var startMs = startStr ? Date.parse(startStr) : NaN;
    var endMs = endStr ? Date.parse(endStr) : NaN;

    var msgBefore = root.querySelector('[data-bf-countdown-message]');
    var msgEnded = root.querySelector('[data-bf-countdown-ended]');
    var heading = root.querySelector('[data-bf-countdown-heading]');
    var timerEl = root.querySelector('[data-bf-countdown-timer]');
    var elDays = root.querySelector('[data-bf-cd-days]');
    var elHours = root.querySelector('[data-bf-cd-hours]');
    var elMinutes = root.querySelector('[data-bf-cd-minutes]');
    var elSeconds = root.querySelector('[data-bf-cd-seconds]');

    // Detecta quais unidades foram RENDERIZADAS pelo Liquid (checkboxes do editor).
    // Se a caixa não existe no DOM, aquela unidade está desligada nas propriedades da section.
    var showDays = !!elDays;
    var showHours = !!elHours;
    var showMinutes = !!elMinutes;
    var showSeconds = !!elSeconds;

    function show(el, on) {
      if (!el) return;
      if (on) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }

    function pad2(n) {
      return String(Math.max(0, n | 0)).padStart(2, '0');
    }

    function fmtBig(n) {
      n = Math.max(0, n | 0);
      return n < 100 ? pad2(n) : String(n);
    }

    function setZeros() {
      if (elDays) elDays.textContent = '00';
      if (elHours) elHours.textContent = '00';
      if (elMinutes) elMinutes.textContent = '00';
      if (elSeconds) elSeconds.textContent = '00';
    }

    if (!endStr || Number.isNaN(endMs)) {
      show(msgBefore, false);
      show(msgEnded, true);
      show(heading, false);
      show(timerEl, false);
      setZeros();
      return;
    }

    var hasStart = startStr && !Number.isNaN(startMs);

    function tick() {
      var now = Date.now();

      if (hasStart && now < startMs) {
        show(msgBefore, true);
        show(msgEnded, false);
        show(heading, false);
        show(timerEl, false);
        setZeros();
        return;
      }

      if (now >= endMs) {
        show(msgBefore, false);
        show(msgEnded, true);
        show(heading, false);
        show(timerEl, false);
        setZeros();
        return;
      }

      show(msgBefore, false);
      show(msgEnded, false);
      show(heading, true);
      show(timerEl, true);

      var distance = endMs - now;
      var totalSeconds = Math.floor(distance / 1000);

      // Cálculo em cascata que ABSORVE as unidades desligadas na unidade
      // ativa imediatamente maior. Ex.: dias desligado -> horas recebe dias*24 + horas.
      var days = 0, hours = 0, minutes = 0, seconds = 0;
      var remaining = totalSeconds;

      if (showDays) {
        days = Math.floor(remaining / 86400);
        remaining -= days * 86400;
      }
      if (showHours) {
        hours = Math.floor(remaining / 3600);
        remaining -= hours * 3600;
      }
      if (showMinutes) {
        minutes = Math.floor(remaining / 60);
        remaining -= minutes * 60;
      }
      if (showSeconds) {
        seconds = remaining;
      }

      // fmtBig na maior unidade ativa (pode passar de 99); pad2 nas demais.
      if (elDays) elDays.textContent = fmtBig(days);
      if (elHours) elHours.textContent = showDays ? pad2(hours) : fmtBig(hours);
      if (elMinutes) elMinutes.textContent = (showDays || showHours) ? pad2(minutes) : fmtBig(minutes);
      if (elSeconds) elSeconds.textContent = (showDays || showHours || showMinutes) ? pad2(seconds) : fmtBig(seconds);
    }

    tick();

    var intervalId = setInterval(function() {
      if (!document.body.contains(root)) {
        clearInterval(intervalId);
        return;
      }
      tick();
    }, 1000);
  });
}

document.addEventListener('DOMContentLoaded', initMadesaCountdowns);

document.addEventListener('shopify:section:load', initMadesaCountdowns);